<template>
  <div v-if="!reviewSubmitted" class="container mt-5">
    <!--to submit review-->
    <div class="row">
      <div class="col pe-0">
        <div class="icon-close" @click="closeForm()">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            class="icon"
          >
            <path
              fill="#000"
              d="M15.89 14.696l-4.734-4.734 4.717-4.717c0.4-0.4 0.37-1.085-0.030-1.485s-1.085-0.43-1.485-0.030l-4.717 4.717-4.671-4.671c-0.4-0.4-1.085-0.37-1.485 0.030s-0.43 1.085-0.030 1.485l4.671 4.671-4.688 4.688c-0.4 0.4-0.37 1.085 0.030 1.485s1.085 0.43 1.485 0.030l4.688-4.687 4.734 4.734c0.4 0.4 1.085 0.37 1.485-0.030s0.43-1.085 0.030-1.485z"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h1 class="display-4 text-center">Write A Review</h1>
      </div>
    </div>
    <form>
      <!-- name/email-->
      <div class="row">
        <div class="col-md-6 mb-2">
          <label
            >Name: <span class="required">*</span
            ><span class="error" v-if="formErrors.displayName">{{
              formErrors.displayName
            }}</span></label
          >
          <input
            v-model="reviewForm.display_name"
            class="form-control"
            type="text"
          />
        </div>
        <div class="col-md-6 mb-2">
          <label
            >Email: <span class="required">*</span
            ><span class="error" v-if="formErrors.email">{{
              formErrors.email
            }}</span></label
          >
          <input v-model="reviewForm.email" class="form-control" type="text" />
        </div>
      </div>
      <!-- title/rating-->
      <div class="row">
        <div class="col-md-8 mb-2">
          <label
            >Review Title: <span class="required">*</span
            ><span class="error" v-if="formErrors.title">{{
              formErrors.title
            }}</span></label
          >
          <input
            v-model="reviewForm.review_title"
            class="form-control"
            type="text"
          />
        </div>
        <div class="col-md-4 mb-2">
          <label
            >Rating: <span class="required">*</span
            ><span class="error" v-if="formErrors.rating">{{
              formErrors.rating
            }}</span></label
          >
          <fieldset class="rating-stars">
            <span class="star-cb-group">
              <input
                type="radio"
                id="rating-5"
                name="rating"
                value="5"
                v-model="reviewForm.review_score"
              /><label for="rating-5">5</label>
              <input
                type="radio"
                id="rating-4"
                name="rating"
                value="4"
                v-model="reviewForm.review_score"
              /><label for="rating-4">4</label>
              <input
                type="radio"
                id="rating-3"
                name="rating"
                value="3"
                v-model="reviewForm.review_score"
              /><label for="rating-3">3</label>
              <input
                type="radio"
                id="rating-2"
                name="rating"
                value="2"
                v-model="reviewForm.review_score"
              /><label for="rating-2">2</label>
              <input
                type="radio"
                id="rating-1"
                name="rating"
                value="1"
                v-model="reviewForm.review_score"
              /><label for="rating-1">1</label>
            </span>
          </fieldset>
        </div>
      </div>
      <!--review-->
      <div class="row">
        <div class="col mb-2">
          <label
            >Review <span class="required">*</span
            ><span class="error" v-if="formErrors.content">{{
              formErrors.content
            }}</span></label
          >
          <textarea
            v-model="reviewForm.review_content"
            class="form-control"
          ></textarea>
        </div>
      </div>
      <!-- optional fit info -->
      <!-- TODO: unhide and add logic for *if apparel/kids/packs whatever* -->
      <div class="d-none">
        <div class="row mt-4">
          <div class="col">
            <p class="display-5">Optional Fit Information</p>
          </div>
        </div>
        <!--size-->
        <div class="row">
          <div class="form-group col-md-6 mb-2">
            <label for="inputState">Size Purchased:</label>
            <select id="inputState" class="form-control">
              <option></option>
              <option :value="SizePurchased.xxs">
                {{ SizePurchased.xxs }}
              </option>
              <option :value="SizePurchased.xs">{{ SizePurchased.xs }}</option>
              <option :value="SizePurchased.s">{{ SizePurchased.s }}</option>
              <option :value="SizePurchased.m">{{ SizePurchased.m }}</option>
              <option :value="SizePurchased.l">{{ SizePurchased.l }}</option>
              <option :value="SizePurchased.xl">{{ SizePurchased.xl }}</option>
              <option :value="SizePurchased.xxl">
                {{ SizePurchased.xxl }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label for="inputState">Usual Size:</label>
            <select id="inputState" class="form-control">
              <option></option>
              <option :value="SizePurchased.xxs">
                {{ SizePurchased.xxs }}
              </option>
              <option :value="SizePurchased.xs">{{ SizePurchased.xs }}</option>
              <option :value="SizePurchased.s">{{ SizePurchased.s }}</option>
              <option :value="SizePurchased.m">{{ SizePurchased.m }}</option>
              <option :value="SizePurchased.l">{{ SizePurchased.l }}</option>
              <option :value="SizePurchased.xl">{{ SizePurchased.xl }}</option>
              <option :value="SizePurchased.xxl">
                {{ SizePurchased.xxl }}
              </option>
            </select>
          </div>
        </div>
        <!--height/weight-->
        <div class="row">
          <div class="form-group col-md-6 mb-2">
            <label for="inputState">Height:</label>
            <select id="inputState" class="form-control">
              <option></option>
              <option :value="CustomerHeight.underFourFootSix">
                {{ CustomerHeight.underFourFootSix }}
              </option>
              <option :value="CustomerHeight.fourFootsixToFiveFoot">
                {{ CustomerHeight.fourFootsixToFiveFoot }}
              </option>
              <option :value="CustomerHeight.fiveFootToFiveFootSix">
                {{ CustomerHeight.fiveFootToFiveFootSix }}
              </option>
              <option :value="CustomerHeight.fiveFootSixToSixFoot">
                {{ CustomerHeight.fiveFootSixToSixFoot }}
              </option>
              <option :value="CustomerHeight.sixFootToSixFootSix">
                {{ CustomerHeight.sixFootToSixFootSix }}
              </option>
              <option :value="CustomerHeight.overSixFootSix">
                {{ CustomerHeight.overSixFootSix }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label for="inputState">Weight:</label>
            <select id="inputState" class="form-control">
              <option></option>
              <option :value="CustomerWeight.below100">
                {{ CustomerWeight.below100 }}
              </option>
              <option :value="CustomerWeight.max125">
                {{ CustomerWeight.max125 }}
              </option>
              <option :value="CustomerWeight.max145">
                {{ CustomerWeight.max145 }}
              </option>
              <option :value="CustomerWeight.max165">
                {{ CustomerWeight.max165 }}
              </option>
              <option :value="CustomerWeight.max185">
                {{ CustomerWeight.max185 }}
              </option>
              <option :value="CustomerWeight.max200">
                {{ CustomerWeight.max200 }}
              </option>
              <option :value="CustomerWeight.max220">
                {{ CustomerWeight.max220 }}
              </option>
              <option :value="CustomerWeight.over220">
                {{ CustomerWeight.over220 }}
              </option>
            </select>
          </div>
        </div>
        <!--body type/fit-->
        <div class="row">
          <div class="form-group col-md-6 mb-2">
            <label for="inputState">Body Type:</label>
            <select id="inputState" class="form-control">
              <option></option>
              <option :value="BodyType.triangle">
                {{ BodyType.triangle }}
              </option>
              <option :value="BodyType.invertedTriangle">
                {{ BodyType.invertedTriangle }}
              </option>
              <option :value="BodyType.rectangle">
                {{ BodyType.rectangle }}
              </option>
              <option :value="BodyType.oval">
                {{ BodyType.oval }}
              </option>
              <option :value="BodyType.hourglass">
                {{ BodyType.hourglass }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-6 mb-2">
            <label for="inputState">Overall Fit:</label>
            <select id="inputState" class="form-control">
              <option></option>
              <option>Runs Small</option>
              <option>True to Size</option>
              <option>Runs Large</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col text-center text-md-end mb-2">
          <button
            class="btn btn-black my-3"
            type="button"
            role="tab"
            aria-label="Click the button to write a review"
            aria-controls="write-review-tabpanel-main-widget"
            aria-expanded="false"
            @click="validateForm(reviewForm)"
          >
            Submit Review
          </button>
        </div>
      </div>
    </form>
  </div>

  <div v-if="reviewSubmitted" class="container mt-5">
    <div class="row">
      <div class="col pe-0">
        <div class="icon-close" @click="closeForm()">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            class="icon"
          >
            <path
              fill="#000"
              d="M15.89 14.696l-4.734-4.734 4.717-4.717c0.4-0.4 0.37-1.085-0.030-1.485s-1.085-0.43-1.485-0.030l-4.717 4.717-4.671-4.671c-0.4-0.4-1.085-0.37-1.485 0.030s-0.43 1.085-0.030 1.485l4.671 4.671-4.688 4.688c-0.4 0.4-0.37 1.085 0.030 1.485s1.085 0.43 1.485 0.030l4.688-4.687 4.734 4.734c0.4 0.4 1.085 0.37 1.485-0.030s0.43-1.085 0.030-1.485z"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="lead text-center">Thank you for submitting a review!</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="text-center">
          Please check back in a few days to see your review.
        </p>
      </div>
    </div>
  </div>
</template>

<script src="./ctrl-review-forms.js"></script>
